import type { BrandTheme } from '../data/brandThemes'

/**
 * Hue-matched outlines for coloured tags. Literal strings so Tailwind
 * generates them; brands with `outlineTags: false` get no outline.
 */
const TAG_OUTLINES: Record<string, string> = {
  indigo: 'border border-indigo-500/30',
  blue: 'border border-blue-500/30',
  pink: 'border border-pink-500/30',
  rose: 'border border-rose-500/30',
  green: 'border border-green-500/30',
  emerald: 'border border-emerald-500/30',
  amber: 'border border-amber-500/30',
  purple: 'border border-purple-500/30',
  gray: 'border border-gray-500/30',
}

export type TagHue = keyof typeof TAG_OUTLINES

export const tagOutline = (theme: BrandTheme, hue: string): string =>
  theme.outlineTags ? TAG_OUTLINES[hue] || TAG_OUTLINES.gray : ''
